import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

// get current time
export const useGetCurrentTimeQuery = (onComplete: (data: Date) => void) => {
	return useQuery({
		queryKey: ['getCurrentTime'],
		queryFn: () => {
			const date = new Date();
			return date;
		},
		refetchInterval: 15000,
		refetchIntervalInBackground: true,
		onSuccess(data) {
			onComplete(data);
		},
	});
};

const useCurrentTime = (): number => {
	const { data } = useGetCurrentTimeQuery(data => {
		setCurrentTime(data.getMilliseconds());
	});

	const [currentTime, setCurrentTime] = useState<number>(data?.getMilliseconds() || new Date().getMilliseconds());

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentTime(currentTime => currentTime + 1000);
		}, 1000);

		return () => {
			clearInterval(interval);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return currentTime;
};

export { useCurrentTime };
